import { render, staticRenderFns } from "./Jobup.vue?vue&type=template&id=61b63936&scoped=true"
import script from "./Jobup.vue?vue&type=script&lang=js"
export * from "./Jobup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b63936",
  null
  
)

export default component.exports